<app-item-base [open]="open" [showHeader]="false">
  <p class="name" placement="right">
    テキスト検索検索
  </p>

  <div class="keyword-body edit-field">
    <textarea type="text" placeholder="テキスト検索" [(ngModel)]="searchParams.keyword" name="keyword_search" placement="right" (blur)="onBlur()"
      (keydown)="EnterOnSearchBox($event)"></textarea>

    <button type="button" (click)="resetSearchkeyword()"><span></span></button>
  </div>

</app-item-base>